// src/components/home/HomeBanner.jsx

import React from 'react';
import HomeBannerImage from '../../assets/images/welcome_home.png';

const HomeBanner = () => {
    return (
        <div className="max-w-7xl mx-auto px-7">
            <div className="overflow-hidden rounded-xl shadow-md">
                <img
                    src={HomeBannerImage}
                    alt="Selamat Datang di GPIB Kasih Karunia"
                    className="w-full h-auto object-cover"
                />
            </div>
        </div>

    );
};

export default HomeBanner;
